<div class="menu">
  <dsd-button
    theme="red"
    (dsdButtonClick)="isMenuOpened = !isMenuOpened"
    icon-name="navigations_contour_chevron_petit_bas"
    icon-position="end"
  >
    DEBUG
  </dsd-button>
  <div *ngIf="isMenuOpened" class="options dsd-pb-sm dsd-pt-sm">
    <p class="dsd-t-6 dsd-ml-sm dsd-fw-bold">Projet</p>
    <div>
      <dsd-options-menu-item (click)="changeTypeProjet('MPM', 'DSD')">MPM_DSD</dsd-options-menu-item>
      <dsd-options-menu-item (click)="changeTypeProjet('PME_REMPLACER')">PME_REMPLACER</dsd-options-menu-item>
      <dsd-options-menu-item (click)="changeTypeProjet('PME_SECONDAIRE')">PME_SECONDAIRE</dsd-options-menu-item>
    </div>
    <hr />
    <ng-container *ngComponentOutlet="capaciteDebugComponent"></ng-container>
    <hr />
    <ng-template *ngComponentOutlet="preautorisationDebugComponent"></ng-template>
    <hr />
    <div class="dsd-m-sm">
      <p class="dsd-t-6 dsd-fw-bold">Notification</p>

      <dsd-select
        class="dsd-mb-sm"
        name="page"
        (dsdSelectChange)="addNotification(notificationType[$event.detail.value])"
      >
        <span slot="label">Declencher une notidication</span>
        <span slot="options">
          <option *ngFor="let notification of notificationTypeKeys" [value]="notification">{{ notification }}</option>
        </span>
      </dsd-select>
    </div>
  </div>
</div>
